import { render, staticRenderFns } from "./disabled-editor.vue?vue&type=template&id=1cb29f11&scoped=true"
import script from "./disabled-editor.vue?vue&type=script&lang=js"
export * from "./disabled-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb29f11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb29f11')) {
      api.createRecord('1cb29f11', component.options)
    } else {
      api.reload('1cb29f11', component.options)
    }
    module.hot.accept("./disabled-editor.vue?vue&type=template&id=1cb29f11&scoped=true", function () {
      api.rerender('1cb29f11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/disabled-editor.vue"
export default component.exports